module.exports = __webpack_public_path__ + "2556c62874d5887e7520ecb5ba6192bb.svg";